// removed by extract-text-webpack-plugin
module.exports = {"ProductAnnouncementTakeover":"ProductAnnouncementTakeover---3b6P4","Headline":"Headline---2s7N3","ScrollableArea":"ScrollableArea---xXC1z","Content":"Content---2rQ_z","SenderInfoWrapper":"SenderInfoWrapper---2lhLs","SenderInfo":"SenderInfo---1t38N","SenderCompanyName":"SenderCompanyName---3k_Y5","Message":"Message---1ZRiJ","Footer":"Footer---3E1xw"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/shared-web/src/components/widget/TakeoverCampaign/ProductAnnouncement/style.styl
// module id = aFTp
// module chunks = 88